<div class="modal-body sticky modal-container" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="sticky-header-container">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="modal-title" ngbAutofocus tabindex="-1" style="outline: none">{{ modalTitle }}</div>
      <app-close-button *ngIf="!hideClose" (closeClicked)="closeClicked.emit()" />
    </div>
  </div>
  <div class="sticky-body-container">
    <ng-content></ng-content>
  </div>
  <div class="sticky-footer-container modal-footer-flex-end">
    <app-button
      *ngIf="!hideSecondary"
      [ngClass]="{ 'secondary-button': !hidePrimary }"
      [type]="ButtonTypeEnum.secondary"
      [loading]="isLoading"
      (buttonClick)="secondaryClicked.emit()">
      {{ secondaryLabel }}
    </app-button>
    <app-button
      *ngIf="!hidePrimary"
      [type]="ButtonTypeEnum.primary"
      [loading]="isLoading"
      [disabled]="disablePrimary"
      (buttonClick)="primaryClicked.emit()">
      {{ primaryLabel }}
    </app-button>
  </div>
</div>
